var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7071 0.292893L11.6129 0.209705C11.2206 -0.0953203 10.6534 -0.0675907 10.2929 0.292893L10.2097 0.387101C9.90468 0.779392 9.93241 1.34662 10.2929 1.70711L12.585 4H4L3.88338 4.00673C3.38604 4.06449 3 4.48716 3 5C3 5.55228 3.44772 6 4 6H15L15.1136 5.99402C15.9277 5.90718 16.3097 4.89547 15.7071 4.29289L11.7071 0.292893ZM13.002 9C13.002 8.44771 12.5543 8 12.002 8H1.002L0.888374 8.00598C0.0743371 8.09282 -0.307677 9.10453 0.294898 9.70711L4.2949 13.7071L4.38911 13.7903C4.7814 14.0953 5.34863 14.0676 5.70911 13.7071L5.7923 13.6129C6.09733 13.2206 6.0696 12.6534 5.70911 12.2929L3.417 10H12.002L12.1186 9.99327C12.616 9.93551 13.002 9.51284 13.002 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompare);
export default __webpack_public_path__ + "static/media/compare.7ae113c26a50fa9e655eddea58b109a6.svg";
export { ForwardRef as ReactComponent };